/**
 *  ----------------------------------------------------------------
 *  Copyright © Backbase B.V.
 *  ----------------------------------------------------------------
 *  Author : Backbase R&D - Amsterdam - New York
 *  Filename : main.js
 *  Description: ${widget.description}
 *  ----------------------------------------------------------------
 */

define(function (require, exports, module) {
    'use strict';
    
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            };
        i[r].l = 1 * new Date();
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.append(a, m);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

    var base = require('base');
    var core = require('core');

    var deps = [
        core.name
    ];
    module.name = 'met-accounts-analytics';

    // @ngInject
    var run = function (lpWidget) {
        var account = lpWidget.getPreference('gaAccount');

        window.ga('create', account, 'auto');
        window.ga('send', 'pageview');

        if ($('body.designMode').length) {
            $(lpWidget.body).text('Google Analytics account: ' + account);
        }
    };

    module.exports = base.createModule(module.name, deps)
        .run(run);

    var url = window.location.pathname;
    window.gadgets.pubsub.subscribe('ga', function () {
        // prevent duplicates
        window.setTimeout(function () {
            if (url !== window.location.pathname) {
                url = window.location.pathname;
                window.ga('send', 'pageview', url);
            }
        }, 100);
    });
});



// WEBPACK FOOTER //
// ./scripts/main.js